import { render, staticRenderFns } from "./_productTypes.vue?vue&type=template&id=5de44b10&scoped=true&"
import script from "./_productTypes.vue?vue&type=script&lang=js&"
export * from "./_productTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de44b10",
  null
  
)

export default component.exports